module.exports = __webpack_public_path__ + "img/airConditioner.7b0e9ff3.svg";